<template>
  <div class="search" :class="{ opacity0: professionMore == 0 }">
    <ul class="ml20 part03">
      <li class="flex nowrap start" ref="profession">
        <dt class="nowrap title">讲师标签：</dt>
        <dd
          class="flex flex1"
          :class="{
            mr50: professionMore > 1,
            'height34px ohide': professionMore == 2,
          }"
        >
          <a :class="{ on: LabelID == 0 }" @click="LabelID = 0">全部</a>
          <a
            @click="LabelID = item.LabelID"
            :class="{ on: LabelID == item.LabelID }"
            v-for="(item, index) in classifyList"
            :key="index"
            >{{ item.LabelName }}</a
          >
        </dd>
        <dd
          v-if="professionMore > 1"
          class="absolute r t mt27 Conhover C888 pointer"
        >
          <p v-if="professionMore == 2" @click="professionMore = 3">
            展开 <i class="el-icon-arrow-down"></i>
          </p>
          <p v-if="professionMore == 3" @click="professionMore = 2">
            收起 <i class="el-icon-arrow-up"></i>
          </p>
        </dd>
      </li>
    </ul>
  </div>
</template>

<script>
import { Teacher_GetLabels } from "@/api/teacher";
export default {
  name: "teacherTypeList",
  data() {
    return {
      classifyList: [],
      LabelID: 0,
      professionMore: 0, // 0隐藏  1单行显示 2多行收起 3多行展开
    };
  },
  watch: {
    LabelID(v) {
      this.$router.replace({
        query: { ...this.$route.query, LabelID: v },
      });
    },
  },
  methods: {},
  async created() {
    let { LabelID } = this.$route.query;
    if (LabelID) {
      LabelID = Number(LabelID);
      this.LabelID = LabelID;
    }
    Teacher_GetLabels().then((res) => {
      this.classifyList = res.data;
    });
    this.$nextTick(() => {
      this.professionMore = this.$refs.profession.offsetHeight > 80 ? 2 : 1;
    }, 50);
  },
};
</script>

<style lang="scss" scoped>
.search {
  margin-top: 30px;

  width: 1760px;
  padding: 0 10px;
  padding-bottom: 10px;
  background: #ffffff;
  border-radius: 10px;
  font-size: 16PX;
  color: #333333;
  .title {
    padding: 5px 0;
    color: #666666;
    margin-right: 10px;
  }
  .navbar {
    gap: 50px;
    padding: 20px 0;
    margin-left: 15px;
    border-top: 1px solid #e6e6e6;
    .actives {
      color: #1d79ff;
    }
    .navbar-item {
      cursor: pointer;
      img {
        margin-right: 5px;
      }
      .recommend {
        width: 16px;
        height: 15px;
        margin-top: -2px;
      }
      .new {
        width: 25pxx;
        height: 14px;
      }
      .hot {
        width: 22px;
        height: 17px;
      }
    }
  }
}
</style>
